import { CheckCircle2, Circle } from 'lucide-react'
import { evaluatePjAgradaCompleteness } from '@/utils/pjAgradaCompleteness'
import type { GestorEquipeDetail } from '@/services/gestoresService'
import { cn } from '@/utils/cn'

export function GestorEquipeDadosCompleteness({ detail }: { detail: GestorEquipeDetail }) {
  const result = evaluatePjAgradaCompleteness({
    nomeCompleto: detail.nomeCompleto,
    email: detail.email,
    telefone: detail.telefone,
    cpf: detail.cpf,
    cnpj: detail.cnpj,
    razaoSocial: detail.razaoSocial,
    cep: detail.cep,
    logradouro: detail.logradouro,
    numero: detail.numero,
    cidade: detail.cidade,
    uf: detail.uf,
    bancoNome: detail.bancoNome,
    bancoAgencia: detail.bancoAgencia,
    bancoConta: detail.bancoConta,
    bancoTipoConta: detail.bancoTipoConta,
    pixChave: detail.pixChave,
  })

  return (
    <div className='rounded-xl border border-white/[0.06] bg-white/[0.03] p-4'>
      <div className='mb-3 flex items-center justify-between gap-2'>
        <p className='text-sm font-semibold text-text-primary'>Completude do cadastro</p>
        <span
          className={cn(
            'rounded-full px-2.5 py-0.5 text-xs font-bold',
            result.complete
              ? 'bg-emerald-500/15 text-emerald-400'
              : 'bg-amber-500/15 text-amber-400',
          )}
        >
          {result.percent}%
        </span>
      </div>
      <ul className='grid gap-1.5 sm:grid-cols-2'>
        {result.fields.map((field) => (
          <li key={field.key} className='flex items-center gap-2 text-xs'>
            {field.ok ? (
              <CheckCircle2 size={14} className='shrink-0 text-emerald-500' />
            ) : (
              <Circle size={14} className='shrink-0 text-amber-500' />
            )}
            <span className={field.ok ? 'text-text-muted' : 'text-text-primary'}>{field.label}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
